<template>
  <hic-list-page title="就诊登记" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="患者" exportable @export="exportExcel">
    <!-- <template slot="buttons">
      <el-button type="primary" @click="meta.showEditor = true" size="small">
        <i class="el-icon-plus"></i> 新建
      </el-button>
    </template> -->
    <template slot="search">
      <el-date-picker style="width: 15rem" size="small" @change="changeDate" value-format="yyyy-MM-dd" v-model="dateRange" type="daterange" :picker-options="$utils.Dt.picker([], '<=')" range-separator="至" start-placeholder="开始时间" end-placeholder="截止时间"></el-date-picker>
      <el-input class="condition-input left-pad" size="small" v-model="condition.doctorName" placeholder="医生" @keyup.enter.native="page" clearable @clear="page"/>
    </template>
    <el-table-column align="center" label="操作" width="100" key="iousCmd">
      <template slot-scope="{ row }">
        <el-button type="primary" title="编辑" size="mini" icon="el-icon-edit" circle plain @click="inDetail(row)"></el-button>
        <!-- <el-button type="danger" title="删除" size="mini" icon="el-icon-delete" circle plain @click="delNurse(row)"></el-button> -->
      </template>
    </el-table-column>
    <el-table-column label="姓名" prop="patientName" align="center" />
    <el-table-column label="性别" prop="patientGender" align="center" width="50">
      <template slot-scope="{ row }">
        {{ row.patientGender | dictText("Gender") }}
      </template>
    </el-table-column>
    <el-table-column label="年龄" prop="patientAge" align="center" />

    <el-table-column label="就诊时间" prop="date" width="150" align="center">
      <template slot-scope="{ row }">
        {{ row.date | fmtDate }} {{ row.time }}
      </template>
    </el-table-column>
    <el-table-column label="联系电话" prop="phone" align="center" />
    <el-table-column label="住址" prop="address" align="center" />
    <el-table-column label="诊断" align="center">
      <el-table-column label="西医" prop="diagnosis" align="center" width="150" />
      <el-table-column label="中医" prop="diagnosisChn" align="center" width="150" />
    </el-table-column>
    <el-table-column label="会诊" align="center">
      <el-table-column label="专科" prop="specialized" align="center" />
      <el-table-column label="二三线" prop="secondOrThirdTier" align="center" />
    </el-table-column>
    <el-table-column label="初诊" prop="" align="center">
      <template slot-scope="{ row }">
        {{ !row.ifSubsequent ? "是" : "否" }}
      </template>
    </el-table-column>
    <!-- <el-table-column label="复诊" prop="" align="center">
      <template slot-scope="{ row }">
        {{ row.repeatDiagnoses ? row.repeatDiagnoses : ""}}
      </template>
    </el-table-column> -->

    <el-table-column label="绿色通道" prop="" align="center">
      <template slot-scope="{ row }">
        {{ row.ifGreenChannel ? "是" : "" }}
      </template>
    </el-table-column>
    <el-table-column label="群伤" prop="" align="center">
      <template slot-scope="{ row }">
        {{ row.ifCrowdHarm ? "是" : "" }}
      </template>
    </el-table-column>
    <el-table-column label="危重等级" prop="patientName" align="center">
      <template slot-scope="{ row }">
        <el-tag v-if="row.criticalLevel == Enum.CriticalLevel.濒危 || row.criticalLevel == 1" type="danger" effect="dark" size="small">{{ row.criticalLevel }}</el-tag>
        <el-tag v-else-if="row.criticalLevel == Enum.CriticalLevel.危重 || row.criticalLevel == 2" type="danger" hit size="small">{{ row.criticalLevel }}</el-tag>
        <el-tag v-else-if="row.criticalLevel == Enum.CriticalLevel.急症 || row.criticalLevel == 3" type="warning" hit size="small">{{ row.criticalLevel }}</el-tag>
        <el-tag v-else-if="row.criticalLevel == Enum.CriticalLevel.非急症 || row.criticalLevel == 4" type="info" hit size="small">{{ row.criticalLevel }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="手术名称" prop="surgeryName" align="center" />
    <el-table-column label="手术分级" prop="surgeryGrade" align="center">
      <template slot-scope="{ row }">
        {{ row.surgeryGrade | dictText("SurgeryGrade") }}
      </template>
    </el-table-column>
    <el-table-column label="中医特色治疗" prop="chineseTreat" align="center"></el-table-column>
    <el-table-column label="转归" align="center">
      <el-table-column label="会诊" prop="consultationMemo" align="center">
        <template slot-scope="{ row }">
          {{ row.consultationMemo || (row.ifConsultation ? "是" : "否") }}
        </template>
      </el-table-column>
      <el-table-column label="留观" prop="observationMemo" align="center">
        <template slot-scope="{ row }">
          {{ row.observationMemo || (row.ifObservation ? "是" : "否") }}
        </template>
      </el-table-column>
      <el-table-column label="抢救" prop="rescueMemo" align="center">
        <template slot-scope="{ row }">
          {{ row.rescueMemo || (row.ifRescue ? "是" : "否") }}
        </template>
      </el-table-column>
      <el-table-column label="住院" prop="ipMemo" align="center">
        <template slot-scope="{ row }">
          {{ row.ipMemo || (row.ifIp ? "是" : "否") }}
        </template>
      </el-table-column>
      <el-table-column label="转院" prop="transferMemo" align="center">
        <template slot-scope="{ row }">
          {{ row.transferMemo || (row.ifTransfer ? "是" : "否") }}
        </template>
      </el-table-column>
      <el-table-column label="死亡" prop="deadMemo" align="center">
        <template slot-scope="{ row }">
          {{ row.deadMemo || (row.ifDead ? "是" : "否") }}
        </template>
      </el-table-column>
    </el-table-column>
    <el-table-column label="传染病报卡" prop="infectiousDiseaseCard" align="center" />
    <el-table-column label="不良事件" prop="adverseEvent" align="center" />
    <el-table-column label="输血" prop="bloodTransfusion" align="center" />
    <el-table-column label="首诊医生" prop="doctorName" align="center" />
    <el-table-column label="备注" prop="bookMemo" align="center" />
    <reg-editor :infoDetail="selInfo" :visible.sync="meta.showEditor" @close="page" />
  </hic-list-page>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      "reg-editor": () => import("./editor"),
    },
    data() {
      return {
        dateRange: [],
        condition: {
          keyword: null,
          deptCode: null,
          doctorName: null,
          sort: "id",
          asc: false,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        entities: {},
        selectedDict: null,
        meta: {
          loading: false,
          showEditor: false,
        },
        entity: {},
        selInfo: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "permission", "user", "Enum"]),
    },
    methods: {
      changeDate() {
        if (this.dateRange && this.dateRange.length) {
          this.$set(this.condition, "startDate", this.dateRange[0]);
          this.$set(this.condition, "endDate", this.dateRange[1]);
        } else {
          this.$set(this.condition, "startDate", null);
          this.$set(this.condition, "endDate", null);
        }
        this.page();
      },
      page() {
        this.meta.loading = true;
        this.condition.deptCode = this.user.deptCode;
        api.OpTreatment.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            if (err && err != "cancel") {
              this.$message.error(err.message || err);
            }
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      inDetail(row) {
        this.selInfo = this.$utils.Obj.clone(row);
        this.meta.showEditor = true;
      },
      delNurse(row) {
        this.$confirm("确定要删除记录？", "警告", { type: "warning" })
          .then(() => {
            this.meta.loading = true;
            api.OpTreatment.del(row.id)
              .then((res) => {
                this.meta.loading = false;
                this.init();
              })
              .catch((err) => {
                this.meta.loading = false;
                this.$message.error(err);
              });
          })
          .catch((e) => {});
      },
      exportExcel() {
        let con = this.$utils.Obj.clone(this.condition);
        delete con.pageSize;
        delete con.pageIndexOnView;
        api.OpTreatment.export(con, `登记本.xls`, [
          { property: "dateTime", title: "就诊时间" },
          { property: "phone", title: "联系电话" },
          { property: "patientName", title: "姓名" },
          { property: "patientGender", title: "性别", dict: this.dict.Gender },
          { property: "patientAge", title: "年龄" },
          { property: "address", title: "住址" },
          { property: "diagnosis", title: "西医" },
          { property: "diagnosisChn", title: "中医" },
          { property: "specialized", title: "专科" },
          { property: "secondOrThirdTier", title: "二三线" },
          { property: "ifSubsequent", title: "初诊", dict: this.$utils.Dict.bool() },
          { property: "ifGreenChannel", title: "绿色通道" , dict: this.$utils.Dict.bool()},
          { property: "ifCrowdHarm", title: "群伤" , dict: this.$utils.Dict.bool()},
          { property: "criticalLevel", title: "危重等级" },
          { property: "surgeryName", title: "手术名称" },
          { property: "surgeryGrade", title: "手术分级", dict: this.dict.SurgeryGrade },
          { property: "chineseTreat", title: "中医特色治疗" },
          { property: "ifConsultation", title: "会诊", dict: this.$utils.Dict.bool() },
          { property: "consultationMemo", title: "会诊备注" },
          { property: "ifObservation", title: "留观", dict: this.$utils.Dict.bool() },
          { property: "observationMemo", title: "留观备注" },
          { property: "ifRescue", title: "抢救", dict: this.$utils.Dict.bool() },
          { property: "rescueMemo", title: "抢救备注" },
          { property: "ifIp", title: "住院", dict: this.$utils.Dict.bool() },
          { property: "ipMemo", title: "住院备注" },
          { property: "ifTransfer", title: "转院", dict: this.$utils.Dict.bool() },
          { property: "transferMemo", title: "转院备注" },
          { property: "ifDead", title: "死亡", dict: this.$utils.Dict.bool() },
          { property: "deadMemo", title: "死亡备注" },
          { property: "infectiousDiseaseCard", title: "传染病报卡" },
          { property: "adverseEvent", title: "不良事件" },
          { property: "bloodTransfusion", title: "输血" },
          { property: "doctorName", title: "首诊医生" },
          { property: "bookMemo", title: "备注" },

          // { property: "patientSource", title: "患者来源", dict: this.dict.PatientSource },
          // { property: "chiefComplaints", title: "来诊主诉" },
          // { property: "vsBodyTemperature", title: "体温", format: "%s ℃" },
          // { property: "vsSphygmus", title: "脉搏", format: "%s 次/分" },
          // { property: "vsBreath", title: "呼吸", format: "%s 次/分" },
          // { property: "vsBloodPressureSystolic", title: "收缩压", format: "%s mmHg" },
          // { property: "vsBloodPressureDiastolic", title: "舒张压", format: "%s mmHg" },
          // { property: "vsBloodSugar", title: "血糖", format: "%s mmol/L" },
          // { property: "vsBloodPotassium", title: "血钾", format: "%s mmol/L" },
          // { property: "specialGroup", title: "特殊群体", dict: this.dict.SpecialGroup },
          // { property: "criticalLevel", title: "病情分级" },
          // { property: "emergencyDivision", title: "分区(红/黄/绿)", dict: this.dict.EmergencyDivision },
          //{ property: "whereAbouts", title: "去向(住院/离院/死亡/转科)", dict: this.dict.WhereAbouts },
          //{ property: "leaveTime", title: "离开时间" },
          // { property: "vsExtend1", title: "签名" }
        ]);
      },
    },
  };
</script>

<style scoped></style>
